import { DismissReason } from "../../helpers/enums";

export class FormEventArgs {
  constructor(public sender: DismissReason, public event: string) {}
}
